module.exports = __webpack_public_path__ + "assets1752041109707/img/lan5.01bd8a8d.png";